import axios from 'axios'
import {
  Notification,
  MessageBox,
  Message
} from 'element-ui'
import store from '@/store'
import { getToken } from './auth.js'
import errorCode from './errorCode'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers['token'] = localStorage.getItem('token');
axios.defaults.headers['Authorization'] = localStorage.getItem('token');
export function request(config) {
  // 1.创建axios的实例
  const instance = axios.create({
    // baseURL: 'https://dmo.ws-nocode.cn/', // 服务器连接地址
    // baseURL: 'https://system.ws-nocode.cn/', // 服务器连接地址
    baseURL: 'http://ws-nocode.com:81/', // 服务器连接地址
    timeout: 60000
  })
 
  // 2.axios的拦截器
  instance.interceptors.request.use(config => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    if (getToken() && !isToken) {
      // config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token') // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers['token'] = localStorage.getItem('token')
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?';
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof (value) !== "undefined") {
          if (typeof value === 'object') {
            for (const key of Object.keys(value)) {
              let params = propName + '[' + key + ']';
              var subPart = encodeURIComponent(params) + "=";
              url += subPart + encodeURIComponent(value[key]) + "&";
            }
          } else {
            url += part + encodeURIComponent(value) + "&";
          }
        }
      }
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    return config
  }, err => {
    console.log(err)
    Promise.reject(err)
  })

  // 2.2相应拦截

  // 添加响应拦截器
  instance.interceptors.response.use(function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    return response.data;
  }, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    console.log(error.request);
    //响应状态码
    var status = error.request.status;
    console.log(status)
    //响应数据
    var data = error.response.data;
    if (status === 401) {
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.clear();
        store.dispatch('LogOut').then(() => {
          location.href = '/menu';
        })
      })
    }


    var message = "请求错误，请可联系相关人员进行排查";
    if (data && data.message) {
      message = data.message;
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    // 对响应错误做点什么
    return Promise.reject(error);
  });

  // instance.interceptors.response.use(res => {
  //   // // 未设置状态码则默认成功状态
  //   console.log(res)
  //   const code = res.data.code || 1;
  //   // 获取错误信息
  //   const msg = errorCode[code] || res.data.msg || errorCode['default']
  //   if (code === 401) {
  //     MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
  //       confirmButtonText: '重新登录',
  //       cancelButtonText: '取消',
  //       type: 'warning'
  //     }).then(() => {
  //       store.dispatch('LogOut').then(() => {
  //         location.href = '/menu';
  //       })
  //     })
  //   } else if (code === 500) {
  //     Message({
  //       message: msg,
  //       type: 'error'
  //     })
  //     return Promise.reject(new Error(msg))
  //   } else {
  //     console.log(res.data)
  //     return res.data
  //   }
  // }, err => {
  //   console.log(err)
  //   console.log('err' + err)
  //   let {
  //     message
  //   } = err;
  //   if (message == "Network Error") {
  //     message = "后端接口连接异常";
  //   } else if (message.includes("timeout")) {
  //     message = "系统接口请求超时";
  //   } else if (message.includes("Request failed with status code")) {
  //     message = "系统接口" + message.substr(message.length - 3) + "异常";
  //   }
  //   Message({
  //     message: message,
  //     type: 'error',
  //     duration: 5 * 1000
  //   })
  //   return Promise.reject(err)
  // })

  //3.发送真正的网络请求
  return instance(config)
}



// WEBPACK FOOTER //
// ./src/until/axios.js